import { useIntl } from "react-intl";

import { PersistentDrawer } from "@/components/Drawer/PersistentDrawer";

type Props = {
  travellersSelected: number;
  travellersToSelect: number;
};

export function TravellerSelectionStatusDrawer({
  travellersSelected,
  travellersToSelect,
}: Props) {
  const intl = useIntl();

  return (
    <PersistentDrawer
      shouldNotTrackHeight
      noShadow
      noBorder
      backgroundColor={
        travellersSelected === travellersToSelect
          ? "var(--color-surface-accent-soft)"
          : "var(--color-surface-neutral-medium)"
      }
      padding="calc(var(--spacing)*2) calc(var(--spacing)*4) calc(var(--drawer-height,0) + var(--spacing)*2)"
    >
      <p className="text-center text-sm">
        {intl.formatMessage(
          {
            defaultMessage: "{selectedCount} of {totalCount} selected",
            description:
              "Summary of how many travellers have been assigned out of the total",
          },
          {
            selectedCount: travellersSelected,
            totalCount: travellersToSelect,
          },
        )}
      </p>
    </PersistentDrawer>
  );
}
